import { Dialog } from '@material-ui/core';
import React, { useState, useMemo } from 'react';
import { Divider } from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import CloseIcon from '@material-ui/icons/Close';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import CustomRadio from 'components/CustomRadio';
import CustomButton from 'components/CustomInput/Button';
import { UPDATE_DRAFT_COMMENT } from 'store/key';
import {
    APPLICANT,
    CCO,
    CLUSTER_ADMIN,
    DRAFT,
    IRB,
} from 'utility/lookup';

const SFooter = styled.div`
    padding: 15px;
    display: flex;
    justify-content:right;
`;

const SHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
    padding: 15px;
`;

const SelectTemplateDialog = ({
    isShow = false,
    maxWidth = 'sm',
    user = {},
    width = 500,
    onClose = () => null,
    handleConfirm = () => { },
}) => {

    const dispatch = useDispatch();
    // const user = useSelector((state) => state.user);
    const [selectedTemplate, setSelectedTemplate] = useState('C');

    const onCustomClose = () => {
        onClose();
        setSelectedTemplate('');
    }

    const onConfirm = () => {
        onCustomClose();
        handleConfirm?.(selectedTemplate);
    }

    return (
        <Dialog
            open={isShow}
            style={{ margin: 'auto' }}
            maxWidth={maxWidth}
        >
            <div
                style={{ minWidth: width }}
            >
                <SHeaderContainer>
                    <div style={{ marginRight: 'auto', fontSize: '18px', fontWeight: 500 }}>Please select export template</div>
                    <CloseIcon style={{ cursor: 'pointer' }} onClick={onCustomClose} />
                </SHeaderContainer>
                <Divider style={{ width: '100%' }} />
                <div style={{ display: 'flex', minHeight: '200px', flexDirection: 'column' }}>
                    <div style={{ padding: '10px 100px 10px 100px' }}>
                        {/* <div style={{ padding: '35px 0 20px 0' }}>
                            Please select template:
                        </div> */}
                        {/* <CustomOutlineSelect
                            value={selectedTemplate}
                            onChange={(e) => {
                                setSelectedTemplate(e.target.value);
                            }}
                            choices={[
                                {
                                    key: 'C',
                                    display: 'CCO Template',
                                },
                                {
                                    key: 'S',
                                    display: 'Secretary Template',
                                },
                                {
                                    key: 'H',
                                    display: 'Head Office Administrator Template',
                                },
                            ]}
                        /> */}
                        <CustomRadio
                            value={selectedTemplate}
                            onChange={(e) => {
                                setSelectedTemplate(e.target.value);
                            }}
                            flexDirection='column'
                            isRequired
                            operators={[
                                {
                                    key: 'C',
                                    label: 'On-going Applications',
                                },
                                {
                                    key: 'S',
                                    label: '(Pending)',
                                },
                                {
                                    key: 'H',
                                    label: '(Pending)',
                                },
                            ]}
                        />
                    </div>
                    <div style={{ color: 'red', margin: '15px' }}>Note: Only approved documents will be exported.</div>
                    <Divider style={{ width: '100%' }} />
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', padding: '15px 30px 15px 0' }}>
                        <CustomButton
                            style={{ marginLeft: 20 }}
                            onClick={onConfirm}
                            autoFocus
                            disabled={selectedTemplate == 'S' || selectedTemplate == 'H'}
                        >
                            Confirm
                        </CustomButton>
                        <CustomButton type={'cancel'} onClick={onCustomClose}>
                            Cancel
                        </CustomButton>
                    </div>
                </div>
                {/* <Divider style={{ width: '100%' }} /> */}
            </div>
        </Dialog>
    );
};


export {
    SelectTemplateDialog
};
